import React, { useContext, useState } from "react"
import { useHistory } from 'react-router-dom';
import FieldItem from "../../../../components/ModalItem/FieldItem"
import Card from "../../../../components/Card/Card"
import Button from "../../../../components/Button"
import { showToast, startLoading, stopLoading } from "../../../../services/common-service"
import api from "../../../../factory/api"
import { AppContext } from "../../../../contexts/AppContext";
import BlipPortalToastTypes from "../../../../constants/blip-portal-toast-types";

const NewTicketForm = ({
    chooseTenant = false
}) => {
    const history = useHistory()
    const { user, appInfo } = useContext(AppContext)

    const [data, setData] = useState({})

    const submit = async () => {
        try {
            startLoading()

            let body = {
                ...data,
                botId: data?.botId || appInfo?.shortName,
                author: chooseTenant ? {
                    name: "Blip Partner (abertura direta)",
                    email: "blippartner@sharkdev.com.br",
                    admin: true
                } : {
                    name: user?.fullName,
                    email: user?.email,
                    phone: user?.phoneNumber,
                    admin: false
                }
            }

            let tenantId = chooseTenant ? data.tenantId : appInfo?.tenantId

            let { data: { ticket } } = await api.post("/tickets", body, {
                headers: {
                    tenantId
                }
            })

            const message = "Chamado aberto com sucesso"

            showToast({
                type: BlipPortalToastTypes.SUCCESS,
                message
            })

            setData({})

            if (chooseTenant) {
                alert(message)
            } else
                history.push(`/ticket/${ticket?.ticketId}`)
        } catch (error) {
            console.error(error)

            const message = error?.response?.data?.message || "Ocorreu um erro. Contacte a SharkDev."

            showToast({
                type: BlipPortalToastTypes.DANGER,
                message
            })

            if (chooseTenant) {
                alert(message)
            }
        } finally {
            stopLoading()
        }
    }

    return (
        <div className="flex flex-column" style={{ gap: 20, paddingTop: 20 }}>
            <Card>
                <bds-typo variant="fs-16" bold="light" margin={false}>Nos conte com o máximo de detalhes o que está acontecendo. Quanto mais informações você compartilhar (prints, mensagens, contexto ou horário do ocorrido), mais rápido poderemos ajudar você!</bds-typo>
                <bds-typo variant="fs-16" bold="light" margin={false}>🕒 Nosso time analisa todos os chamados com atenção e retornará o quanto antes.</bds-typo>
            </Card>

            {/* {JSON.stringify(data)} */}
            <Card>
                <div className="flex flex-column" style={{ gap: 20 }}>
                    {[
                        ...(chooseTenant ? [
                            {
                                "label": "Cliente (obrigatório)",
                                "name": "tenantId",
                                "type": "select-http",
                                "headers": [
                                    // {
                                    //     "key": "Authorization",
                                    //     "value": "Bearer 7ca0c29c-352d-4611-90d4-54890661ca85"
                                    // }
                                ],
                                "fields_trigger": [],
                                "url": "https://api.painel.sharkdev.com.br/api/tickets/tenants",
                                "path_array": "tenants",
                                "attr_text_list": "",
                                "attr_text": "name",
                                "attr_value": "tenantId"
                            },
                            {
                                "label": "ID do Bot / Roteador",
                                "name": "botId",
                                "type": "text"
                            },
                        ] : []),
                        {
                            "label": "Tipo de chamado (obrigatório)",
                            "name": "type",
                            "type": "select",
                            "options": [
                                {
                                    "value": "27adc194-e07f-4fe0-ad8d-ed433a82f6d2",
                                    "name": "Suporte técnico"
                                },
                                {
                                    "value": "ccbc418b-db90-4b2c-816a-bdaeed2c2cc6",
                                    "name": "Solicitação"
                                },
                                {
                                    "value": "fd13ba1e-12f1-49ee-9277-389735df7d88",
                                    "name": "Outros"
                                }
                            ]
                        },
                        {
                            "label": "Assunto (obrigatório)",
                            "name": "subject",
                            "type": "text"
                        },
                        {
                            "label": "Descrição (obrigatório)",
                            "name": "description",
                            "type": "textarea"
                        },
                        ...(chooseTenant ? [] : [
                            {
                                "label": "Arquivos",
                                "name": "files",
                                "type": "file-list"
                            }
                        ])
                    ].map((field, index) =>
                        <FieldItem
                            key={index}
                            data={data}
                            setData={setData}
                            index={index}
                            field={field}
                            setValue={(key, value) => {
                                setData(data => {
                                    data[key] = value
                                    return { ...data }
                                })
                            }}
                        // isNew={isNew}
                        // externalData={externalData}
                        // setExternalData={setExternalData}
                        />
                    )}

                    <div className="flex justify-end" style={{ gap: 10 }}>
                        <Button
                            variant={"solid"}
                            color="content"
                            text={"Cancelar"}
                            onClick={() => setData({})}
                        // size="short"
                        />

                        <Button
                            variant={"primary"}
                            text={"Enviar"}
                            onClick={() => submit()}
                            disabled={!data?.type || !data?.subject || !data?.description}
                        // size="short"
                        />
                    </div>
                </div>
            </Card>
        </div>
    )
}

export default NewTicketForm